import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });

const loadPaddle = (cfg) => new Promise((resolve, reject) => {
  const init = () => {
    if (cfg.env === "sandbox") window.Paddle.Environment.set("sandbox");
    window.Paddle.Initialize({ token: cfg.client_token });
    resolve();
  };
  if (window.Paddle) { init(); return; }
  const s = document.createElement("script");
  s.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
  s.onload = init;
  s.onerror = reject;
  document.head.appendChild(s);
});

// Backup checkout: only used when Admin has switched payments to Paddle. Returns false → use Stripe as normal.
export const openPaddleIfActive = async ({ plan, partner_ref = null, source = null, returnPath = "/voice-clone" }) => {
  let p;
  try { p = (await axios.get(`${API}/api/billing/provider`, auth())).data; } catch { return false; }
  if (p.provider !== "paddle") return false;
  await loadPaddle(p.paddle);
  const { data } = await axios.post(`${API}/api/paddle/checkout-intent`, { plan, partner_ref, source }, auth());
  const sep = returnPath.includes("?") ? "&" : "?";
  window.Paddle.Checkout.open({
    items: [{ priceId: data.price_id, quantity: 1 }],
    customer: { email: data.email },
    customData: data.custom_data,
    settings: { successUrl: `${window.location.origin}${returnPath}${sep}paddle=1` },
  });
  return true;
};
